import type { TopicResponse } from '~/models/topic/TopicResponse.api.model';
import FetchFactory from '../factory';

const TOPIC_CONTROLLER_PATH = '/api-electra/Topic';

class Topic extends FetchFactory<any> {
  async getTopicByPageUrl(url: string): Promise<TopicResponse> {
    return await this.get(
      `${TOPIC_CONTROLLER_PATH}/GetTopicByPageUrl/url/${url}`,
    );
  }
}

export default Topic;
